import { Organisation } from '@/features'
import { ScoresContext } from './context'

export const ScoreReviews = () => {
  const params = ScoresContext.useScoresContext((c) => c.params)
  const organisation = ScoresContext.useScoresContext(
    (c) => c.profile?.data?.organization,
  )

  return (
    <Organisation.EmployeeReviews
      {...params}
      organisation={organisation as Organisation.T.Organisation}
    />
  )
}
